import { isTimestampAfterCurrentDate } from "../helpers/datetimeHelper";
export function validRedemptionRules(RedemptionRules, storeZone) {
  let validRedemptionRules = RedemptionRules.filter(
    pt =>
      !pt.Disable &&
      (!pt.ExpiredDate ||
        (pt.ExpiredDate &&
          isTimestampAfterCurrentDate(pt.ExpiredDate.seconds, storeZone)))
  );
  return validRedemptionRules.sort((a, b) => {
    return a.DiscountRate - b.DiscountRate;
  });
}
export function redemptionMatchConditions(
  RedemptionRule,
  userRedemptionPoints,
  redemptionLocalUsedPoints
) {
  return (
    userRedemptionPoints - redemptionLocalUsedPoints >= RedemptionRule.Point
  );
}

export function calcSavedPoints(
  RedemptionRules,
  orderItems,
  IsEarnPointsWhenRedeem
) {
  var points = 0;
  for (var orderItem of orderItems.filter(
    p => !p.reedemptionRule || (p.reedemptionRule && IsEarnPointsWhenRedeem)
  )) {
    for (var RedemptionRule of RedemptionRules) {
      //meet conditions
      var matchConditions = true;
      //ProductCategoryConditions
      if (RedemptionRule.Categories && RedemptionRule.Categories.length > 0) {
        matchConditions =
          RedemptionRule.Categories.filter(
            p =>
              !orderItem.ProductCategoryIDs ||
              !orderItem.ProductCategoryIDs.includes(p.toString())
          ).length == 0;
      }
      //ProductTagConditions
      if (
        matchConditions &&
        RedemptionRule.Tags &&
        RedemptionRule.Tags.length > 0
      ) {
        matchConditions =
          RedemptionRule.Tags.filter(
            p =>
              !orderItem.ProductTagIDs ||
              !orderItem.ProductTagIDs.includes(p.toString())
          ).length == 0;
      }
      if (matchConditions) {
        points += orderItem.RewardPoint * orderItem.quantity;
        break;
      }
    }
  }
  return points;
}
